import React from 'react';
import PropTypes from 'prop-types';

const PostDateTime = ({ datetime }) => (
  <p style={{ marginBottom: '.75em' }}>
    <time style={{ opacity: 0.5 }}>
      <small>{datetime}</small>
    </time>
  </p>
);

PostDateTime.propTypes = {
  datetime: PropTypes.string.isRequired,
};

export default PostDateTime;



// WEBPACK FOOTER //
// ./src/components/PostDateTime.js